export const TOKEN_KEY = 'shui_app_h5_key';

export const DEV = process.env.NODE_ENV == 'development';

export const CHECK_STATE = {
    1: '未核验',
    2: '已核验',
};

export const CHECK_STATE_MAP = {
    check: 2,
    noCheck: 1,
};

export const VERIFY_TIME = 30; //发送验证码时间间隔

export const VERIFY_TIME_KEY = 'dl_sms_token_key'; // 存储验证码发送时间key
export const CHANGE_MOBILE_VERIFY_TIME_KEY = 'dl_change_mobile_sms_token_key'; // 更换手机号验证码发送时间key
export const SYS_START_DATE = '2019-05-01'; // 系统开始日期
